export enum Role {
  Admin = 'Admin',
  Doctor = 'Employee',
  Patient = 'Patient',
  TenantAdmin = 'TenantAdmin',
}

export enum RootModule {
  Admin = 'admin',//Super admin
  Doctor = 'doctor',//Doctor Panel  
  Patient = 'patient-cabinet',// Patient Panel
  ClinicAdmin = 'clinic-admin',// Clinic Administrator Panel
}
